import { render } from "./CharacterSelectionView.vue?vue&type=template&id=544209b0&scoped=true&ts=true"
import script from "./CharacterSelectionView.vue?vue&type=script&lang=ts"
export * from "./CharacterSelectionView.vue?vue&type=script&lang=ts"

import "./CharacterSelectionView.scss?vue&type=style&index=0&id=544209b0&scoped=true&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-544209b0"]])

export default __exports__